<ng-container *ngIf="(seoInfoForRender$ | async) && !domHasNoindex">
    <section class="mt-48 mb-48 text-center">
        <h2 class="copy-title ttu text-l mb-32">{{ (seoInfoForRender$ | async)?.secondaryTitle }}</h2>
        <paragraph-toggle [content]="(seoInfoForRender$ | async)?.longDescription" maxHeight="74"></paragraph-toggle>
    </section>

    <div class="seo-separator"></div>
</ng-container>

<ng-container *ngIf="(relatedCategories$ | async)?.length > 0">
    <div class="pt-48 pb-48 text-center">
        <div class="row">
            <div class="col-xs-12">
                <h2 class="text-l ttu">{{ 'dev.categories.grid.seo.interestYou' | translate }}</h2>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 pt-24 category-seo">
                <ul class="category-seo-list list-group-mb text-l">
                    <li *ngFor="let category of relatedCategories$ | async">
                        <a
                            class="link-raw text-l has-ellipsis"
                            (click)="changeCategoryFilter($event, category.locationPath)"
                            [href]="category.locationPath"
                            [title]="category.seoCategory?.mainHeader + ' ' + (lastSectionTranslated$ | async)"
                            elementObserverDirective
                            [observeType]="'promotion'"
                            [observeLink]="{ categoryId: category?.id }"
                        >
                            {{ category.name }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-container>
